<mat-form-field
  class="example-chip-list"
  [floatLabel]="myFloatLabel && myFloatLabel !== 'never' ? myFloatLabel : 'auto'"
  (click)="openPanel()"
>
  <mat-chip-grid #chipGrid>
    @for (chips of selectedChips; track chips) {
      <mat-chip-row [matTooltip]="showTooltip ? (optionObj ? chips.text : chips) : null" (removed)="remove(chips)">
        {{ optionObj ? chips.text : chips }}
        @if (iconPath) {
          <button class="remove-icon" matChipRemove>
            <span class="icon-remove" [inlineSVG]="iconPath"></span>
          </button>
        }
        @if (!iconPath) {
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
    }
  </mat-chip-grid>
  <div class="input-container">
    <input
      #searchInput
      [placeholder]="placeholder"
      [formControl]="inputCtrl"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
      (ngModelChange)="onInputValueChanged($event)"
      (focus)="userInputChange = true; showInputPlaceholder = false"
      (blur)="userInputChange = false; showInputPlaceholder = true"
    />
    @if ((inputCtrl.value === null || inputCtrl.value?.length === 0) && showSearchPlaceholder && showInputPlaceholder) {
      <div class="input-search-placeholder">
        {{ searchPlaceholderText | transloco }}
      </div>
    }
  </div>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    @for (option of filteredOptions | async; track option) {
      <mat-option [value]="option">
        {{ optionObj ? option.text : option }}
      </mat-option>
    }
    <div #endOfList></div>
  </mat-autocomplete>
</mat-form-field>
